<template>
    <Wrapper>
        <Topbar button="goToPanel" logo="tipbox" step="3/3" />
        <h2 class="text-center mb-3">{{ $t('header') }}</h2>
        <p class="text-center pre-line mb-4">{{ $t('description') }}</p>
        <FeatureColumns :columns="columns" />
    </Wrapper>
</template>

<script>
    import Wrapper from '../../parts/Wrapper.vue';
    import Topbar from '../../parts/Topbar.vue';
    import FeatureColumns from '../../parts/FeatureColumns.vue';

    export default {
        name: 'AccountReady',
        components: {
            Wrapper,
            Topbar,
            FeatureColumns,
        },
        computed: {
            columns() {
                return Object.values(this.$t('columns')).map(column => ({ ...column, items: Object.values(column.items) }));
            },
        },
        created() {
            this.$store.commit('space/setSpacesInitialized', false);
        },
    };
</script>

<i18n lang="json" locale="pl" scope="local">
{
    "header": "Twoje konto jest gotowe 🎉",
    "description": "Wybierz teraz, gdzie chcesz w pierwszej lokejności zacząć zbierać napiwki.\nPamiętaj, że obie opcje możesz skonfigurować później — to tylko wybór, od czego chcesz zacząć.",
    "columns": [
        {
            "title": "Widżet na stronę",
            "description": "Dodaj prosty widżet na swoją stronę lub bloga. Odbiorcy mogą zostawić napiwek bez opuszczania Twojej witryny.",
            "items": ["Idealny dla właścicieli stron, blogerów", "Łatwa implementacja poprzez kod HTML lub wtyczkę do WordPressa"],
            "button": {
                "label": "Wybieram",
                "to": { "name": "WidgeterTipboxSettings" }
            }
        },
        {
            "title": "Profil tipbox.pl na social media",
            "description": "Otrzymuj napiwki przez specjalny link, który możesz dodać do opisu swojego profilu w social mediach albo posta. Zbiera wszystkie napiwki w jednym miejscu.",
            "items": ["Idealny dla twórców na Instagramie, TikToku, YouTube, X (Twitterze) i innych.", "Możesz go podlinkować w socialach, e-mailu czy QR kodzie na ulotce."],
            "button": {
                "label": "Wybieram",
                "to": { "name": "WidgeterTipboxLink" }
            }
        }
    ]
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "header": "Your account is ready 🎉",
    "description": "Now choose where you want to start collecting tips first.\nRemember, you can configure both options later — it’s just a choice of where to begin.",
    "columns": [
        {
            "title": "Website widget",
            "description": "Add a simple widget to your website or blog. Visitors can leave a tip without leaving your site.",
            "items": ["Perfect for website owners and bloggers", "Easy implementation via HTML code or a WordPress plugin"],
            "button": {
                "label": "Select",
                "to": { "name": "WidgeterTipboxSettings" }
            }
        },
        {
            "title": "tipbox.pl profile on social media",
            "description": "Receive tips via a special link that you can add to your social media profile description or post. It gathers all tips in one place.",
            "items": ["Ideal for creators on Instagram, TikTok, YouTube, X (Twitter), and others", "You can link it in social posts, emails, or as a QR code on a flyer"],
            "button": {
                "label": "Select",
                "to": { "name": "WidgeterTipboxLink" }
            }
        }
    ]
}
</i18n>
